import type {
  FilterableLanguage,
  FilterableResponsiveness,
  FilterableShift,
} from '@/core/sourcing/search/consts/hard-filters.const';

// The option lists the filter sidebar offers. Presentation data, not component logic: the ids
// are the values the request carries, the titles are only what the recruiter reads.

/** "Any time" carries id 0 so it reads as falsy and clears the constraint. */
export const LAST_ACTIVE_OPTIONS = [
  { id: 0, title: 'Any time' },
  { id: 1, title: '1 day' },
  { id: 2, title: '2 days' },
  { id: 3, title: '3 days' },
  { id: 7, title: '7 days' },
  { id: 30, title: '30 days' },
  { id: 90, title: '90 days' },
];

/**
 * Distance shares the Location group and has no label of its own, so each title carries the
 * radius in words: the selected value has to read as a radius unaided. Kept to "Within N
 * miles" rather than the design's "Distance within N miles", which is drawn in a 14px field
 * where ours renders 16px and ellipsizes mid-value in the 280px sidebar.
 *
 * The ids are the request's `aroundRadius`, so they stay plain numeric miles whatever the
 * titles say.
 */
export const DISTANCE_OPTIONS = [
  { id: 10, title: 'Within 10 miles' },
  { id: 20, title: 'Within 20 miles' },
  { id: 30, title: 'Within 30 miles' },
  { id: 40, title: 'Within 40 miles' },
  { id: 50, title: 'Within 50 miles' },
  { id: 60, title: 'Within 60 miles' },
  { id: 70, title: 'Within 70 miles' },
  { id: 80, title: 'Within 80 miles' },
  { id: 90, title: 'Within 90 miles' },
  { id: 100, title: 'Within 100+ miles' },
];

export const SHIFT_OPTIONS: Array<{ value: FilterableShift; label: string }> = [
  { value: 'first', label: '1st shift' },
  { value: 'second', label: '2nd shift' },
  { value: 'third', label: '3rd shift' },
];

export const LANGUAGE_OPTIONS: Array<{ value: FilterableLanguage; label: string }> = [
  { value: 'english', label: 'English' },
  { value: 'spanish', label: 'Spanish' },
];

/** The label matches the card's own responsiveness chip, so filter and result read the same. */
export const RESPONSIVENESS_OPTIONS: Array<{
  value: FilterableResponsiveness;
  label: string;
}> = [{ value: 'high', label: 'Historically responsive' }];

export const RECENTLY_OPEN_LABEL = 'Recently open to work';
